import { OkImpl, ok } from './Ok.js';
import { ErrImpl } from './Err.js';
export const isResult = (value) => value instanceof OkImpl || value instanceof ErrImpl;
export const isOk = (value) => value.isOk;
export const isErr = (value) => value.isErr;
export const ensureResult = (value) => (isResult(value) ? value : ok(value));
